import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
export const SwitchingContext = ({ context, changingContext })=>{
    const containerStyle = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh'
    };
    const iframeUrl = `/context.html?organizationName=${encodeURIComponent(context.activeContext?.organizationName || '')}&changingContext=${changingContext}`;
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsx("div", {
            style: containerStyle,
            children: /*#__PURE__*/ _jsx("iframe", {
                src: iframeUrl,
                style: {
                    width: '100%',
                    height: '100%',
                    border: 'none'
                },
                title: "Context Switching"
            })
        })
    });
};
